<template>
<div class="gi-box" :style="{'backgroundImage': data ? 'url(' + data['板块背景'] + ')' : ''}">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="sass">

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.gi-box
  padding: 60px 0
  background-size: cover
  background-position: center
  +mobile
    padding: 30px 0
</style>
